import * as React from 'react';
import { connect } from 'react-redux';

import SignUpForm from '../../forms/signUpForm';
//import { doSignup } from "./actions";
import { StyleSheet, KeyboardAvoidingView } from 'react-native';
import { Container, Header, H2, H3, Content, Text, Label, Item, Input, Icon, Toast, Form, Spinner, View, Left, Right, Body, Button, Title, ScrollView } from 'native-base';

import * as _ from 'lodash';
import Modal from '../../components/modal';
import AuthenticationApi from '../../api/AuthenticationApi';
import CalCalDataApi from '../../api/CalCalDataApi';
import LocalStorage from '../../api/LocalStorage';

//import XDate from 'xdate';

import { formValueSelector, change, SubmissionError } from 'redux-form';

// -- What if we're offline??

class SignUpContainer extends React.Component {
	constructor(props) {
		super(props);

		this.initialState = {
			loggingIn: false,
			registered: false
		};
		this.state = this.initialState;
	}

	componentDidMount() {
		this.getBusTypes();
		this.getRegnonce();
	}

	getBusTypes() {
		CalCalDataApi.dataLoadWithHeads('busTypes', '', res => {
			if (res) {
				this.setState({ busTypes: res });
			} else {
				this.setState({ isError: true });
			}
		});
	}

	getRegnonce() {
		AuthenticationApi.preSignUp(res => {
			if (res && res.success) {
				this.setState({ nonce: res.security, defaultDate: res.defaultDate });
			} else {
				this.setState({ isError: true });
			}
		});
	}

	renderHeader() {
		return (
			<Header>
				<Left>
					<Button transparent onPress={() => this.props.navigation.goBack()}>
						<Icon name="ios-arrow-back" />
					</Button>
				</Left>
				<Body>
					<Title>Sign Up for FREE</Title>
				</Body>
				<Right />
			</Header>
		);
	}

	/*
	async doSignup() {
		this.setState({ loggingIn: true });
		errors = await this.refs.form.submit();
		//etc - set states and return errors
		this.setState({ loggingIn: false });
		console.log('errors', errors);
		if (!errors) {
			__DEV__ && console.log('Submit ok, Going back');
			//this.props.navigation.navigate({ name: 'Login'});
			this.setState({ registered: true });
		} else {
			return errors;
		}
	}*/

	handleSubmit(values) {
		//this.props.doSignup(values, this.state.nonce);
		return AuthenticationApi.signUp(values, this.state.nonce, res => {
			if (res.success) {
				//LocalStorage saves user; access_token, refresh_token but NOT JWT
				//LocalStorage.saveUserAsync(res)
				this.setState({ user: values.username, pass: values.password, registered: true });

				Toast.show({
					text: 'Registration successful',
					duration: 2000,
					position: 'top',
					type: 'success',
					textStyle: { textAlign: 'center' }
				});
				return false;
			} else {
				Toast.show({
					text: res.message,
					duration: 2000,
					position: 'bottom',
					textStyle: { textAlign: 'center' }
				});
				if (res.validationErrors) throw new SubmissionError(res.validationErrors);
			}
		});
	}

	doLogin() {
		const { user, pass } = this.state;
		AuthenticationApi.signIn(user, pass, res => {
			if (!res.error) {
				LocalStorage.saveCredsAsync({ user, pass });
				this.props.dispatch({ type: 'SET_USER', user: { ...res, temppin: true } });
			} else {
				dispatch({ type: SET_LOGIN_ERROR, loginError: res.error_description || true });
				this.props.navigation.navigate({ name: 'Login' });
			}
		});
	}

	render() {
		const head = this.renderHeader();
		//console.log(this.props.formVals);
		if (!this.state.busTypes || !this.state.nonce)
			return (
				<Container style={styles.container}>
					{head}
					<Spinner />
					<Text style={styles.centretxt}>Connecting to CalCal...</Text>
				</Container>
			);
		if (this.state.registered)
			return (
				<Container style={styles.container}>
					{head}
					<Content padder keyboardShouldPersistTaps={'handled'} style={{ paddingBottom: 30 }}>
						<H2>Welcome to CalCal!</H2>
						<Text style={styles.text}>You should shortly receive a text message</Text>
						<Text>We sent an SMS to the mobile number you entered with your temporary PIN.</Text>

						<Button block onPress={() => this.doLogin()}>
							<Text>Continue</Text>
						</Button>
					</Content>
				</Container>
			);
		const initVals = { accountingStartDate: this.state.defaultDate };
		return (
			<Container style={styles.container}>
				{head}

				<Content keyboardShouldPersistTaps={'handled'}>
					<SignUpForm
						ref="form"
						busTypes={this.state.busTypes}
						defaultDate={this.state.defaultDate}
						initialValues={initVals}
						isLtd={!!this.props.formVals.taxtype}
						isLump={!!this.props.formVals.lumpUp}
						onSubmit={this.handleSubmit.bind(this)}
					/>
				</Content>
			</Container>
		);
	}
}

/*
function bindAction(dispatch) {
	return {
		doSignup: (vals, nonce) => dispatch(doSignup(vals, nonce)),
	};
}*/

const selector = formValueSelector('SignUpForm');

const mapStateToProps = state => ({
	//isLoginPending: state.loginReducer.isLoginPending,
	//isLoginSuccess: state.loginReducer.isLoginSuccess,
	//loginError: state.loginReducer.loginError,
	formVals: selector(state, 'taxtype', 'lumpUp')
});

export default connect(mapStateToProps)(SignUpContainer);

const styles = StyleSheet.create({
	container: {
		backgroundColor: '#FBFAFA',
		padding: 0
	},
	row: {
		flex: 1,
		alignItems: 'center'
	},
	text: {
		fontSize: 20,
		marginBottom: 15,
		alignItems: 'center'
	},
	mt: {
		marginTop: 18
	},
	modalStyle: {
		borderRadius: 10,
		width: '90%',
		height: '95%'
	},
	modalContainer: {
		flex: 1,
		//justifyContent: 'center',
		backgroundColor: '#f8f8fc'
	},
	innerContainer: {
		flex: 1
		//alignItems: 'center',
	},
	modalHeader: {
		height: 45,
		borderTopLeftRadius: 10,
		borderTopRightRadius: 10
	},
	centretxt: {
		alignSelf: 'center'
	}
});
